import { Link, createFileRoute } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageContainer } from '@/components/layout/page-container'
import { Button } from '@/components/ui/button'
import { LeadCreateForm } from '@/features/leads/lead-create-form'

/**
 * 新建线索页。
 *
 * 无筛选态,故不需要 search schema —— 冷加载 `/leads/new` 直接可用(A4 纪律的另一面:
 * 页面上没有「视图状态」要还原,URL 就该是干净的一条路径)。
 * 表单本身的规则(买方二选一 / 201 与 200 的区分展示 / referral 禁投放三码)见
 * `features/leads/lead-create-form.tsx`。
 */
export const Route = createFileRoute('/_authed/leads/new')({
  component: LeadCreatePage,
})

function LeadCreatePage() {
  return (
    <PageContainer
      title="新建线索"
      breadcrumbs={[{ label: '线索管理', to: '/leads' }, { label: '新建线索' }]}
      description="客户咨询建档:先定买方与获客渠道,再填客咨要素。建档恒落「新线索」态,阶段推进在详情页。"
      actions={
        <Button variant="outline" asChild>
          <Link to="/leads" search={{}}>
            <ArrowLeft />
            返回列表
          </Link>
        </Button>
      }
    >
      <LeadCreateForm />
    </PageContainer>
  )
}
